import React from 'react';
import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useMediaQuery, useTheme } from '@mui/material';
import { Box } from 'web-library';
import EditButton from '../../../../components/buttons/EditButton';

const useStyles = makeStyles()((theme) =>
({
  buttonContainer: {
    padding: `0px 0px 0px ${theme.spacing(4)}`,
    minWidth: 0,
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(3),
    },
  },
}));

interface ParticularsEditButtonsProps {
  /**
   * Callback method when edit button clicked.
   */
  editHandler: () => void;
}

const ParticularsEditButtons = (props: ParticularsEditButtonsProps) => {
  const { editHandler } = props;
  const theme = useTheme();
  const { classes } = useStyles();
  const { t } = useTranslation();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className={classes.buttonContainer}>
      <EditButton
        label={isMobile ? '' : t('components->>IconLabel.EditParticular')}
        editHandler={editHandler}
      />
    </Box>
  );
};

export default ParticularsEditButtons;
